import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import { StudioContextProvider } from './contexts/StudioContext';
import reportWebVitals from './reportWebVitals';

// Export for use in other modules (like azureJobs.ts)
export { msalInstance };

// Wrapper for TenantProvider with Real Auth
const TenantProviderWithRealAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const realAuth = useAuth();
  const auth = {
    isAuthenticated: realAuth.isAuthenticated,
    user: realAuth.user,
    getAccessToken: async () => {
      // Return cached token if available
      if (realAuth.accessToken) {
        return realAuth.accessToken;
      }
      // Otherwise throw error - token should be available when authenticated
      throw new Error('Access token not available');
    },
  };
  return <TenantProvider auth={auth}>{children}</TenantProvider>;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Using real Microsoft Entra External ID authentication
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <TenantProviderWithRealAuth>
          <StudioContextProvider>
            <App />
          </StudioContextProvider>
        </TenantProviderWithRealAuth>
      </AuthProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
